import { useServicosDisponiveis, type ServicoDisponivel } from "../../nucleo/operacao";

export interface EscolhaDeServico {
  id: string;
  categoria: string;
  servico: string;
}

/**
 * Os serviços do catálogo que a pessoa pode usar ao abrir um chamado. Some quando o catálogo não
 * tem nada para oferecer (ou não responde): o chamado se abre sem serviço, como sempre se abriu.
 * O que a pessoa não vê aqui o servidor também recusa.
 */
export function SeletorDeServico({
  organizacaoId,
  valor,
  aoMudar,
}: {
  organizacaoId?: string;
  valor: string;
  aoMudar: (escolha: EscolhaDeServico | null) => void;
}) {
  const disponiveis = useServicosDisponiveis(organizacaoId);
  const lista = disponiveis.data ?? [];
  if (lista.length === 0) return null;
  const porCategoria = new Map<string, ServicoDisponivel[]>();
  for (const item of lista) porCategoria.set(item.categoria, [...(porCategoria.get(item.categoria) ?? []), item]);

  return (
    <label className="campo" htmlFor="servico-do-catalogo">
      <span className="campo__rotulo">Serviço (opcional)</span>
      <select
        id="servico-do-catalogo"
        className="campo__controle"
        value={valor}
        onChange={(evento) => {
          const escolhido = lista.find((item) => item.id === evento.target.value);
          aoMudar(escolhido ? { id: escolhido.id, categoria: escolhido.categoria, servico: escolhido.nome } : null);
        }}
      >
        <option value="">Nenhum serviço específico</option>
        {[...porCategoria.entries()].map(([categoria, itens]) => (
          <optgroup label={categoria} key={categoria}>
            {itens.map((item) => <option value={item.id} key={item.id}>{item.nome}</option>)}
          </optgroup>
        ))}
      </select>
    </label>
  );
}
